import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

// Updated SidebarContainer to accept open prop and adjust width
const SidebarContainer = styled.div`
  position: fixed;      
  top: 0;               
  left: 0;              
  height: 100vh; 
  
  z-index: 1000;        
  width: ${props => (props.open ? '270px' : '60px')};
  background: ${({ theme }) => theme.sidebarGradient};
  color: ${({ theme }) => theme.sidebarText};
  padding: 20px 10px;
  box-sizing: border-box;
  box-shadow: 3px 0 8px rgba(0, 0, 0, 0.15);
 
  overflow-x: hidden;
  transition: width 0.2s ease;
  display: flex;
  flex-direction: column;
`;

const SidebarInner = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;

  /* Hide scrollbar for WebKit browsers */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for Firefox */
  scrollbar-width: none;

  /* Hide scrollbar for IE, Edge */
  -ms-overflow-style: none;
`;

// Toggle button styled for top icon/button
const ToggleButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 1.8rem;
  cursor: pointer;
  padding: 8px;
  margin-bottom: 10px;
  align-self: flex-start;

  &:hover {
    background-color: rgba(255 255 255 / 0.2);
    border-radius: 6px;
  }
`;

const Nav = styled.nav`
  margin-top: 10px;
  flex-grow: 1;
  overflow-y: auto;
`;

const StyledLink = styled(Link)`
  display: block;
  padding: 10px 5px;
  color: #cbd5ff;
  text-decoration: none;
  border-radius: 6px;
  font-weight: 500;
  margin-bottom: 8px;
  transition: background-color 0.25s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    background-color: rgba(255 255 255 / 0.15);
    color: white;
  }
`;


// When sidebar is collapsed, hide the text but keep icon area (if any)
const MenuToggle = styled.div`
  cursor: pointer;
  font-weight: 700;
  padding: 12px 15px;
  margin: 15px 0 8px;
  user-select: none;
  border-radius: 6px;
  background-color: rgba(255 255 255 / 0.1);
  transition: background-color 0.2s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    background-color: rgba(255 255 255 / 0.2);
  }
`;

const Submenu = styled.div`
  padding-left: 16px;
`;

const SubmenuLink = styled(StyledLink)`
  font-size: 0.8rem;
  color: #b0bfff;

  &:hover {
    color: white;
  }
`;

export default function Sidebar({ open, toggleSidebar, darkMode }) {
  const [openBeef, setOpenBeef] = useState(false);
  const [openSupp, setOpenSupp] = useState(false);
  const [openDataPrep, setOpenDataPrep] = useState(false);
  const [openMortalityMorbidity, setOpenMortalityMorbidity] = useState(false);
  const [openMorbidityDataPrep, setOpenMorbidityDataPrep] = useState(false);

  return (
    <SidebarContainer open={open} darkMode={darkMode}>
      <SidebarInner>
      <ToggleButton onClick={toggleSidebar}>
        {open ? '☰' : '☰'}
      </ToggleButton>

      {open && (
        <Nav>
          <MenuToggle onClick={() => setOpenBeef(!openBeef)}>
            Original Survey {openBeef ? '▾' : '▸'}
          </MenuToggle>
          {openBeef && (
            <Submenu>
              <MenuToggle onClick={() => setOpenDataPrep(!openDataPrep)}>
                Data Preparation {openDataPrep ? '▾' : '▸'}
              </MenuToggle>
              {openDataPrep && (
                <Submenu>
                  <SubmenuLink to="/beef/data-preparation/abhs2021">Alberta Health Solutions (ABHS)</SubmenuLink>
                  <SubmenuLink to="/beef/data-preparation/cvc2024">Coaldale Veterinary Clinic (CVC)</SubmenuLink>
                  <SubmenuLink to="/beef/data-preparation/fhms2024">Feedlot Health Management Services (FHMS)</SubmenuLink>
                  <SubmenuLink to="/beef/data-preparation/mvs2021">Metzger Veterinary Services (MVS)</SubmenuLink>
                  <SubmenuLink to="/beef/data-preparation/vahs2024">Veterinary Agri-Health Services (VAHS)</SubmenuLink>
                </Submenu>
              )}
              <SubmenuLink to="/beef/templates">Templates</SubmenuLink>
              <SubmenuLink to="/beef/data-uploads">Data Uploads & Procedures</SubmenuLink>
              <SubmenuLink to="/beef/survey-app">Survey App</SubmenuLink>
            </Submenu>
          )}

          <MenuToggle onClick={() => setOpenSupp(!openSupp)}>
            Supplementary Surveys {openSupp ? '▾' : '▸'}
          </MenuToggle>
          {openSupp && (
             <Submenu>
              <MenuToggle onClick={() => setOpenMortalityMorbidity(!openMortalityMorbidity)}>
                Mortality and Morbidity {openMortalityMorbidity ? '▾' : '▸'}
              </MenuToggle>
              {openMortalityMorbidity && (
                <Submenu>
                  <MenuToggle onClick={() => setOpenMorbidityDataPrep(!openMorbidityDataPrep)}>
                    Data Preparation {openMorbidityDataPrep ? '▾' : '▸'}
                  </MenuToggle>
                  {openMorbidityDataPrep && (
                    <Submenu>
                      <SubmenuLink to="/supplementary/data-preparation/fhms">Feedlot Health Management Services</SubmenuLink>
                      <SubmenuLink to="/supplementary/data-preparation/vahs">Veterinary Agri-Health Services</SubmenuLink>
                      <SubmenuLink to="/supplementary/data-preparation/abhs">Alberta Beef Health Solutions</SubmenuLink>
                      <SubmenuLink to="/supplementary/data-preparation/cvc">Coaldale Veterinary Clinic</SubmenuLink>
                      <SubmenuLink to="/supplementary/data-preparation/mvs">Metzger Veterinary Services</SubmenuLink>
                      <SubmenuLink to="/supplementary/data-preparation/bvc">Border Veterinary Clinic</SubmenuLink>
                      <SubmenuLink to="/supplementary/data-preparation/ssvs">Sunny South Veterinary Services</SubmenuLink>
                      <SubmenuLink to="/supplementary/data-preparation/lah">Lloydminster Animal Hospital</SubmenuLink>
                    </Submenu>
                  )}
                </Submenu>
              )}
              <SubmenuLink to="/supplementary/antimicrobial-use">BRD</SubmenuLink> 
            </Submenu>
          )}
        </Nav>
        
      )}
      </SidebarInner>
    </SidebarContainer>
  );
}